import ApiHelper from "./ApiHelper";

class EnterpriseServices {
  static async getEnterpriseList(str) {
    return ApiHelper.getAuthenticated(`enterprise?${str}`);
  }

  static async getCompanyById(id) {
    return ApiHelper.getAuthenticated(`enterprise/info/${id}`);
  }

  static async revokeAccess(id) {
    return ApiHelper.getAuthenticated(`enterprise/access/${id}`);
  }

  static async getMemberById(id) {
    return ApiHelper.getAuthenticated(`members/${id}`);
  }

  static async UpdateEnterprise(body) {
    return ApiHelper.putAuthenticated(`enterprise/${body._id}`, body);
  }

  static async getJobById(id) {
    return ApiHelper.getAuthenticated(`job/${id}`);
  }

  static async UploadCompanyBanner(body) {
    return ApiHelper.postAuthenticatedImage(
      "enterprises/upload-company-banner",
      body
    );
  }

  static async UploadCompanyImage(body) {
    return ApiHelper.postAuthenticatedImage(
      "enterprises/upload-company-image",
      body
    );
  }

  static async getEnterpriseActiveJobs(str) {
    return ApiHelper.getAuthenticated(`enterprise/job?${str}`);
  }

  static async updateMemberById(id, payload) {
    return ApiHelper.putAuthenticated(`members/${id}`, payload);
  }

  static async getJobCandidatesById(id, payload) {
    return ApiHelper.getAuthenticated(`applications/job/${id}`,);
  }

  static async getMembersByJob(id, str) {
    return ApiHelper.getAuthenticated(`members/job/${id}?${str}`,);
  }
}
export default EnterpriseServices;
